import { graphlib } from "@dagrejs/dagre";
import type { GraphNode, RuleGraph } from "./GraphTypes";
import { ensureParsedGraph } from "./GraphParse";

export interface OrderedGoalNode {
  id: string;
  name: string | undefined;
  isGoal: boolean;
  path?: string;
  entity?: string;
  isGlobal: boolean;
}

export const getOrderedGoalNodes = (
  graph: RuleGraph | undefined,
  currentGoal?: string,
  showHidden?: boolean,
): OrderedGoalNode[] => {
  const result: OrderedGoalNode[] = [];
  if (!graph) {
    return result;
  }

  const parsed = ensureParsedGraph(graph);

  for (const nodeId of parsed.nodes()) {
    const node = parsed.node(nodeId) as GraphNode | undefined;
    if (!node) {
      continue;
    }
    if (node.fk || node.identifier) {
      continue;
    }
    if (!showHidden && node.hidden) {
      continue;
    }

    const info: OrderedGoalNode = {
      id: node.id,
      name: node.description,
      isGoal: !((parsed.predecessors(nodeId) || []).length > 0),
      path: node.path,
      entity: node.entity,
      isGlobal: node.entity === "global",
    };
    result.push(info);
  }

  const goals = result.filter((n) => n.isGoal);
  const intermediates = result.filter((n) => !n.isGoal);
  const ordered = [ ...goals, ...intermediates ];

  if (currentGoal) {
    const idx = ordered.findIndex((n) => n.id === currentGoal);
    if (idx > -1) {
      const current = ordered[idx];
      ordered.splice(idx, 1);
      ordered.unshift(current);
    }
  }

  return ordered;
};


